(() => {
  const init = () => {
    document.querySelectorAll('[data-gp-gallery]').forEach(gallery => {
      if (gallery.dataset.gpReady) return;
      gallery.dataset.gpReady = 'true';
      const main = gallery.querySelector('.gp-gallery-main img');
      const full = gallery.querySelector('[data-gp-fullimage]');
      gallery.querySelectorAll('[data-gp-image]').forEach(button => {
        button.addEventListener('click', () => {
          if (!main || !full) return;
          main.src = button.dataset.gpImage;
          main.removeAttribute('srcset');
          main.alt = button.dataset.gpAlt || '';
          main.width = Number(button.dataset.gpWidth);
          main.height = Number(button.dataset.gpHeight);
          full.href = button.dataset.gpFull;
          gallery.querySelectorAll('[data-gp-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
